module.exports = __webpack_public_path__ + "fonts/GaramontAmsterdamBQ-Medium.3941c882.woff";